var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Header, Navbar, BreaksAndLunch } from './components';
import { Button, Checkbox, AptiveIcon } from '@aptive-env/storybook';
import { updatePlanningEmployeeWeeklyShift, fetchPlanningEmployeeWeeklyShift } from 'services/planning';
import { parse, isBefore } from 'date-fns';
import { calculateTimeDifferenceInHours } from 'utils/calculateTimeDifferenceInHours';
import styles from './index.module.scss';
import LoadingGif from 'assets/image/loading.gif';
import { useToast } from 'hooks/useToast';
import { getErrorMessage } from 'utils/error';
var ProfileDrawerModal = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, handleClose = _a.handleClose, selectedEmployee = _a.selectedEmployee, office = _a.office, officeId = _a.officeId, setIsUpdated = _a.setIsUpdated;
    var setToast = useToast().setToast;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(1), activeItem = _c[0], setActiveItem = _c[1];
    var _d = useState([]), shifts = _d[0], setShifts = _d[1];
    var _e = useState([]), checkedStates = _e[0], setCheckedStates = _e[1];
    var _f = useState([]), time = _f[0], setTime = _f[1];
    var _g = useState(false), hasError = _g[0], setHasError = _g[1];
    var _h = useState(), selectedEmployeeWeeklyShifts = _h[0], setSelectedEmployeeWeeklyShifts = _h[1];
    var handleCheckboxChange = function (index) {
        setCheckedStates(function (prevState) {
            return prevState.map(function (checked, idx) { return (idx === index ? !checked : checked); });
        });
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedShifts, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (hasError) {
                        return [2 /*return*/];
                    }
                    updatedShifts = shifts.map(function (shift, index) { return ({
                        day_of_week: shift.day_of_week,
                        shift_type: shift.shift_type,
                        start_at: time[index].start_at,
                        end_at: time[index].end_at
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updatePlanningEmployeeWeeklyShift(selectedEmployee === null || selectedEmployee === void 0 ? void 0 : selectedEmployee.id, officeId, updatedShifts)];
                case 2:
                    _a.sent();
                    setIsOpen(false);
                    setIsUpdated(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setToast({
                        status: 'danger',
                        message: getErrorMessage(error_1),
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleTimeChange = function (index, type, value) {
        var updatedTimeInputs = __spreadArray([], time, true);
        if (type === 'start') {
            updatedTimeInputs[index].start_at = value;
        }
        else {
            updatedTimeInputs[index].end_at = value;
        }
        var startAt = parse(updatedTimeInputs[index].start_at, 'HH:mm:ss', new Date());
        var endAt = parse(updatedTimeInputs[index].end_at, 'HH:mm:ss', new Date());
        if (isBefore(endAt, startAt)) {
            setHasError(true);
        }
        else {
            setHasError(false);
            var workingDuration_1 = calculateTimeDifferenceInHours(updatedTimeInputs[index].start_at, updatedTimeInputs[index].end_at, 1);
            setShifts(function (prevState) { return prevState.map(function (shift, idx) { return (idx === index ? __assign(__assign({}, shift), { working_duration: workingDuration_1 }) : shift); }); });
        }
        setTime(updatedTimeInputs);
    };
    useEffect(function () {
        if (selectedEmployee) {
            fetchPlanningEmployeeWeeklyShift(selectedEmployee.id, officeId)
                .then(function (response) {
                if (response._metadata.success && response.result) {
                    setSelectedEmployeeWeeklyShifts(response.result);
                    setIsLoading(false);
                }
                else {
                    console.error('Got unexpected response from fetching planning employee weekly shift');
                }
            })
                .catch(function (error) {
                setToast({
                    status: 'danger',
                    message: getErrorMessage(error),
                });
                console.error(error);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedEmployee, officeId]);
    var scheduleSection = function () {
        return (_jsxs(_Fragment, { children: [isLoading ? (_jsx("div", __assign({ className: "flex flex-col items-center justify-center h-full" }, { children: _jsx("img", { src: LoadingGif, alt: "loading", className: "w-4" }) }))) : (_jsxs("div", __assign({ className: "flex flex-col p-6" }, { children: [_jsxs("div", __assign({ className: "flex justify-between" }, { children: [_jsx("span", __assign({ className: "font-bold text-2xl text-slate-900" }, { children: "Schedule" })), _jsx(Button, __assign({ onClick: function () { return handleSave(); } }, { children: "Save" }))] })), _jsx("div", __assign({ className: "text-gray-600 text-base font-semibold mt-4" }, { children: "Work Schedule" })), _jsxs("div", { children: [_jsxs("div", __assign({ className: 'grid grid-cols-4 gap-4 text-gray-600 text-base font-semibold mt-4' }, { children: [_jsx("span", { children: "Day" }), _jsx("span", { children: "Start time" }), _jsx("span", { children: "End time" }), _jsx("span", { children: "Total hours" })] })), _jsx("div", { children: shifts.map(function (shift, index) { return (_jsxs("div", __assign({ className: "grid grid-cols-4 gap-4 items-center mt-2" }, { children: [_jsx(Checkbox, __assign({ checked: checkedStates[index], onChange: function () { return handleCheckboxChange(index); }, onClick: function noRefCheck() { }, className: styles.checkBox }, { children: shift.day_of_week })), _jsxs("div", __assign({ className: "relative w-full" }, { children: [_jsx("input", { type: "time", className: "\n                          focus:outline-none w-full h-[38px] border rounded-lg px-2\n                          ".concat(checkedStates[index] && hasError ? 'border-red-600' : 'border-gray-200', "\n                          ").concat(checkedStates[index] ? 'text-gray-900' : 'no-time-icon text-gray-400', "\n                        "), value: time[index].start_at, onChange: function (e) { return handleTimeChange(index, 'start', "".concat(e.target.value, ":00")); }, disabled: !checkedStates[index] }), !checkedStates[index] && (_jsx(AptiveIcon, { className: "absolute top-1/2 transform -translate-y-1/2 right-[13px] w-4 h-4 fill-none stroke-[#9CA3AF]", icon: "clock" }))] })), _jsxs("div", __assign({ className: "relative w-full" }, { children: [_jsx("input", { type: "time", className: "\n                          focus:outline-none w-full h-[38px] border rounded-lg px-2\n                          ".concat(checkedStates[index] && hasError ? 'border-red-600' : 'border-gray-200', "\n                          ").concat(checkedStates[index] ? 'text-gray-900' : 'no-time-icon text-gray-400'), value: time[index].end_at, onChange: function (e) { return handleTimeChange(index, 'end', "".concat(e.target.value, ":00")); }, disabled: !checkedStates[index] }), !checkedStates[index] && (_jsx(AptiveIcon, { className: "absolute top-1/2 transform -translate-y-1/2 right-[13px] w-4 h-4 fill-none stroke-[#9CA3AF]", icon: "clock" }))] })), _jsxs("span", __assign({ className: "text-sm text-gray-600" }, { children: [shift.working_duration, " hours"] }))] }), index)); }) })] })] }))), _jsx(BreaksAndLunch, {})] }));
    };
    var activeSection = function (section) {
        switch (section) {
            case 1:
                return _jsx("div", { children: "Section 1" });
            case 2:
                return scheduleSection();
            case 3:
                return _jsx("div", { children: "Section 3" });
            case 4:
                return _jsx("div", { children: "Section 4" });
            default:
                return _jsx("div", { children: "Section 1" });
        }
    };
    useEffect(function () {
        var _a;
        var shiftArray = Object.entries((_a = selectedEmployeeWeeklyShifts === null || selectedEmployeeWeeklyShifts === void 0 ? void 0 : selectedEmployeeWeeklyShifts.shifts) !== null && _a !== void 0 ? _a : {}).map(function (_a) {
            var date = _a[0], data = _a[1];
            return (__assign({ date: date }, data));
        });
        setShifts(shiftArray);
        setCheckedStates(new Array(shiftArray.length).fill(false));
        setTime(shiftArray.map(function (shift) { return ({
            start_at: shift.start_at,
            end_at: shift.end_at
        }); }));
    }, [selectedEmployeeWeeklyShifts]);
    return (_jsx(_Fragment, { children: isOpen && (_jsxs("div", __assign({ className: "sidebar fixed top-0 left-0 h-full w-full z-[50]" }, { children: [_jsx("div", { className: "bg-[#0000001A] absolute top-0 left-0 h-full w-full", onClick: handleClose }), _jsxs("div", __assign({ className: "flex flex-col absolute right-0 bg-white h-full w-[666px] border overflow-x-hidden transition-all duration-500" }, { children: [_jsx(Header, { selectedEmployee: selectedEmployee, handleClose: handleClose, office: office }), _jsx(Navbar, { setSelectedItem: setActiveItem }), activeSection(activeItem)] }))] }))) }));
};
export default ProfileDrawerModal;
